import { render, staticRenderFns } from "./jsqlx.vue?vue&type=template&id=30959651&"
import script from "./jsqlx.vue?vue&type=script&lang=js&"
export * from "./jsqlx.vue?vue&type=script&lang=js&"
import style0 from "./jsqlx.vue?vue&type=style&index=0&id=30959651&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports